module.exports = __webpack_public_path__ + "img/download.d28a8140.svg";